import Layout from '../../internal/Layout.vue'
import ReportsPage from './reports/reports.vue'

const ReportsRoutes = {
  component: Layout,
  children: [
    {
      name: 'report',
      path: '/',
      component: ReportsPage,
      meta: {
        module: 'relatorios',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
  ],
}

export default ReportsRoutes
